import React from "react";
import { Link } from "react-router-dom";

const Garden = () => {
  return (
    <div className="garden-page">
      <div className="title">
        <h2 className="heading">garden. 🌿</h2>
        <p className="section-subtitle">A digital space to grow ideas - still being cultivated</p>
      </div>

      <div className="garden-content">
        <p>
          Welcome to my little corner of the internet. A space for me to make and tend to ideas, follow trains of thought and just enjoy prattling to myself and anyone who might be so inclined to listen. My digital garden if you will.
        </p>

        <p>
          I'm far from the first to become a digital horticulturalist, and I hope I won't be the last, but I've been a serial note maker and jotter for the longest time, and I wanted a suitable way to share the workings of my brain. That's what this is.
        </p>

        <p>
          Heavily inspired by the wonderful{" "}
          <a href="https://maggieappleton.com/" target="_blank" rel="noreferrer">
            Maggie Appleton
          </a>
          , I hope to carve out my own piece of the internet. All sorts of thoughts, complete or otherwise may find their way here. I'm considering these as 'seeds', 'saplings' and 'shrubs'. All will require tending and are certain to evolve over time, but the latter are likely to be more 'complete' than the former. That's about as structured as I want to be - any more and I'm sure I'd never start.
        </p>

        <p>
          So that's it. Welcome. I hope you get as lost in my thoughts as I do.
        </p>

        <p style={{ marginTop: "30px", fontStyle: "italic" }}>Enjoy</p>

        <div style={{ marginTop: "50px" }}>
          <Link to="/garden/index" style={{ color: "var(--primary-color2)", textDecoration: "none", fontSize: "16px" }}>
            explore the garden →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Garden;
